
import React from 'react';
import Header from '../components/Header';
import Footer from '../components/Footer';
import { Cookie, Link as LinkIcon } from 'lucide-react';
import { Button } from '../components/ui/button';
import { Link } from 'react-router-dom';

const CookiePolicy = () => {
  return (
    <div className="min-h-screen flex flex-col">
      <Header />
      
      <main className="flex-grow pt-28 pb-16">
        <div className="container mx-auto px-6">
          <div className="text-center mb-12">
            <div className="mb-4 flex justify-center">
              <Cookie className="h-12 w-12 text-apple-blue" />
            </div>
            <h1 className="text-4xl font-bold text-apple-text mb-4">
              Cookie Policy
            </h1>
            <p className="text-xl text-apple-text-secondary max-w-3xl mx-auto">
              Last updated: {new Date().toLocaleDateString('en-US', {month: 'long', day: 'numeric', year: 'numeric'})}
            </p>
          </div>

          <div className="max-w-4xl mx-auto bg-white rounded-xl shadow-sm p-8 mb-12">
            <div className="prose prose-apple mx-auto">
              <h2>Introduction</h2>
              <p>
                True Talent Apply ("we," "our," or "us") uses cookies and similar technologies on our website and recruitment platform. This Cookie Policy explains how we use these technologies, what types of cookies we use, and how you can control them.
              </p>
              <p>
                Please read this Cookie Policy carefully. By using our website, you agree to our use of cookies as described in this policy.
              </p>

              <h2>What are Cookies?</h2>
              <p>
                Cookies are small text files that are stored on your device (computer, tablet, or mobile) when you visit a website. They allow the website to recognize your device and remember information about your visit, such as your preferences or login status.
              </p>
              <p>
                Cookies are widely used to make websites work more efficiently, improve user experience, provide website owners with information about how users interact with their website, and enable targeted advertising.
              </p>

              <h2>Types of Cookies We Use</h2>
              <h3>Essential Cookies</h3>
              <p>
                These cookies are necessary for the website to function and cannot be switched off in our systems. They are usually only set in response to actions made by you which amount to a request for services, such as setting your privacy preferences, logging in, or filling in forms.
              </p>
              
              <h3>Performance Cookies</h3>
              <p>
                These cookies allow us to count visits and traffic sources so we can measure and improve the performance of our site. They help us to know which pages are the most and least popular and see how visitors move around the site.
              </p>
              
              <h3>Functional Cookies</h3>
              <p>
                These cookies enable the website to provide enhanced functionality and personalization. They may be set by us or by third-party providers whose services we have added to our pages.
              </p>
              
              <h3>Targeting Cookies</h3>
              <p>
                These cookies may be set through our site by our advertising partners. They may be used by those companies to build a profile of your interests and show you relevant advertisements on other sites.
              </p>

              <h2>Third-Party Cookies</h2>
              <p>
                We may also allow third parties to place cookies on your device when you visit our website. These third parties may include analytics providers, advertising networks, and social media platforms.
              </p>

              <h2>Cookie Consent</h2>
              <p>
                When you first visit our website, you will be presented with a cookie banner that allows you to accept or decline non-essential cookies. You can change your cookie preferences at any time by clicking on the "Cookie Settings" link in the footer of our website.
              </p>

              <h2>Managing Cookies</h2>
              <p>
                Most web browsers allow you to manage your cookie preferences. You can set your browser to refuse cookies, or to alert you when cookies are being sent. The methods for doing so vary from browser to browser, and from version to version.
              </p>
              <p>
                Please note that blocking cookies may impact your experience on our website, as some features may not function properly.
              </p>

              <h2>Cookie Data Collection and Analysis</h2>
              <p>
                We collect and analyze cookie data to understand how users interact with our website and to improve our services. This analysis includes:
              </p>
              <ul>
                <li>Page views and navigation patterns</li>
                <li>User demographics (where available)</li>
                <li>Device and browser information</li>
                <li>Referral sources</li>
                <li>Time spent on site and feature usage</li>
              </ul>
              <p>
                This information helps us optimize our user experience, understand our audience better, and make data-driven improvements to our platform.
              </p>

              <h2>Changes to This Policy</h2>
              <p>
                We may update this Cookie Policy from time to time. The updated version will be indicated by an updated "Last Updated" date.
              </p>

              <h2>Contact Us</h2>
              <p>
                If you have questions or concerns about this Cookie Policy, please contact us.
              </p>
              <div className="mt-6 text-center">
                <Button asChild className="bg-apple-blue hover:bg-apple-blue/90">
                  <Link to="/contact">Contact Us</Link>
                </Button>
              </div>
            </div>
          </div>
        </div>
      </main>

      <Footer />
    </div>
  );
};

export default CookiePolicy;
